// extracted by mini-css-extract-plugin
export default {"stores":"nqPNV","stores__image":"UyWbE","stores__ios-adapt":"m0053","stores__android-adapt":"CeoR2","stores__icon":"HJD1F","stores__icon-full-width":"hh7fV"};